import React from "react";
import CartButtons from "../quantitySelectorAddCart/cartButtons";
import Cartbtn from "../addToCartButton/cartBtn";
import { isAddToCartDisabled } from "../../utils/helper";

export default function ProductActions({
  productInfo,
  productStatusObj,
  onQuantityChange,
  onNotifyMeHandle,
  onSuccess,
  initialQuantity,
  updateCartDetails,
  disableAddToCart,
  pageDetails,
  btnLoading
}) {
  // To render add to cart button
  const renderAddToCartBtns = () => {
    return (
      <CartButtons
        productInfo={productInfo}
        handleQuantityChange={onQuantityChange}
        disableAddToCart={
          !productStatusObj?.isActionEnabled || disableAddToCart
        }
        onSuccess={onSuccess}
        initialQuantity={initialQuantity}
        updateCartDetails={updateCartDetails}
        pageDetails={pageDetails}
        btnLoading={btnLoading}
      />
    );
  };

  // To render notify me button
  const renderNotifyMeBtns = () => {
    return (
      <div>
        <Cartbtn
          onAddToCart={onNotifyMeHandle}
          cartText="到貨通知"
          disableAddToCart={!productStatusObj?.isActionEnabled}
          displayCartIcon={false}
          pageDetails={pageDetails}
        />
      </div>
    );
  };

  // To render default case
  const renderDefaultCartBtns = () => {
    const disableAddToCartByStatus = isAddToCartDisabled(
      productInfo.productStatus
    );
    return (
      <CartButtons
        productInfo={productInfo}
        handleQuantityChange={onQuantityChange}
        onSuccess={onSuccess}
        initialQuantity={initialQuantity}
        updateCartDetails={updateCartDetails}
        disableAddToCart={disableAddToCart || disableAddToCartByStatus}
        pageDetails={pageDetails}
        btnLoading={btnLoading}
      />
    );
  };

  switch (productStatusObj?.actionType) {
    case "AddToCart":
      return renderAddToCartBtns();
    case "NotifyMe":
      return renderNotifyMeBtns();
    default:
      return renderDefaultCartBtns();
  }
}

ProductActions.defaultProps = {
  productInfo: null,
  productStatusObj: null,
  onQuantityChange: () => { },
  onNotifyMeHandle: () => { },
  onSuccess: () => { },
  initialQuantity: 1,
  updateCartDetails: () => { },
  pageDetails: {},
};
